import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 17EEE663-92E4-4AB1-87FE-94F2CD296C4B
 * name water
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/water.svg
 * tags
 * - Home Automation 
 * - Health / Beauty 
 * - Food / Drink 
 * - Weather 
 * - Agriculture 
 */
export const WaterIcon = createSvgIcon(<><path d="M12,20A6,6 0 0,1 6,14C6,10 12,3.25 12,3.25C12,3.25 18,10 18,14A6,6 0 0,1 12,20Z" /></>, 'WaterIcon');
export default WaterIcon